const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


const { protocol, hostname } = window.location;

const parts = hostname.split(".");
const rootDomain = parts.length > 2 ? parts.slice(1).join(".") : hostname;
const PAY_BASE = `${protocol}//pay.${rootDomain}`;

  function getMyshopifyDomain(btn) {
    return (
      btn.dataset.shopMyshopifyDomain ||
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname
    );
  }

  function getCurrency(cart) {
    return (
      (cart && cart.currency) ||
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "USD"
    );
  }
  function redirectToPay(payload) {
    const finalUrl =
      PAY_BASE.replace(/\/$/, "") +
      "/checkouts?payload=" +
      encodeURIComponent(toBase64(JSON.stringify(payload)));

    console.log("PAY PAYLOAD:", payload);
    console.log("PAY FINAL URL:", finalUrl);

    window.location.href = finalUrl;
  }

  async function handleButtonClick(button, action) {
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    const spinner = document.createElement("span");
    spinner.style.cssText = `
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
    border: 2px solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    box-sizing: border-box;
  `;

    button.prepend(spinner);
    const animation = spinner.animate(
      [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
      {
        duration: 700,
        iterations: Infinity,
        easing: "linear",
      },
    );
    try {
      await action();
    } finally {
      animation.cancel();
      spinner.remove();
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }
  // 获取站点 logo（从常见位置或 LD+JSON 中）
  function detectStoreLogo() {
    try {
      const logoSelectors = [
        ".header__logo img",
        ".site-header__logo img",
        ".logo img",
        ".header-logo img",
        ".site-logo img",
        ".brand-logo img",
        '.header img[alt*="logo"]',
        'img[class*="logo"]',
      ];
      for (const sel of logoSelectors) {
        const el = document.querySelector(sel);
        if (el && el.src) {
          let src = el.src;
          if (src.startsWith("http:")) src = src.replace("http:", "https:");
          if (!src.startsWith("http")) {
            if (src.startsWith("//")) src = "https:" + src;
            else if (src.startsWith("/")) src = window.location.origin + src;
          }
          return src;
        }
      }
      const ldJsons = document.querySelectorAll(
        'script[type="application/ld+json"]',
      );
      for (const s of ldJsons) {
        try {
          const parsed = JSON.parse(s.textContent);
          if (parsed["@type"] === "Organization" && parsed.logo) {
            return typeof parsed.logo === "string"
              ? parsed.logo
              : parsed.logo.url;
          }
        } catch (e) {}
      }
      const metaImg =
        document.querySelector('meta[property="og:image"]') ||
        document.querySelector('meta[name="twitter:image"]');
      if (metaImg && metaImg.content) return metaImg.content;
      return null;
    } catch (e) {
      return null;
    }
  }
  async function btnGoPay(btn) {
    const myshopifyDomain = getMyshopifyDomain(btn);
    const logo = detectStoreLogo();
    
    if (btn.classList.contains("custom-buy-now-button")) {
      const productForm =
        btn.closest("form") ||
        document.querySelector('form[action*="/cart/add"]');

      if (!productForm) {
        throw new Error("Product form not found");
      }

      const variantInput =
        productForm.querySelector(".product-variant-id") ||
        productForm.querySelector('[name="id"]');

      if (!variantInput || !variantInput.value) {
        throw new Error("Variant ID not found");
      }

      const quantityInput = productForm.querySelector('[name="quantity"]');
      const variantId = Number(variantInput.value);
      const quantity = quantityInput
        ? Math.max(1, parseInt(quantityInput.value || "1", 10))
        : 1;

      const productJsonUrl =
        window.location.pathname.replace(/\/$/, "") + ".js";

      const productRes = await fetch(productJsonUrl, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!productRes.ok) {
        throw new Error("product .js failed");
      }

      const product = await productRes.json();

      const variant =
        (product.variants || []).find(function (v) {
          return Number(v.id) === variantId;
        }) ||
        (product.variants || [])[0] ||
        {};

      const priceCents = Number(variant.price || product.price || 0);
      const price = priceCents / 100;
      const image =
        product.featured_image ||
        (Array.isArray(product.images) && product.images.length
          ? product.images[0]
          : "");

      const payload = {
        store_domain: myshopifyDomain,
        domain_name: window.location.host,
        store_currency: getCurrency(null),
        item_count: quantity,
        store_logo: logo,
        amount: price * quantity,
        products: [
          {
            title: product.title || "Product",
            variant_title: variant.title || "",
            quantity: quantity,
            price: price,
            image: image,
            id: product.id || "",
          },
        ],
      };
      redirectToPay(payload);
      return;
    }

    
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    const cartRes = await fetch(root + "cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!cartRes.ok) {
      const cartText = await cartRes.text();
      throw new Error("cart.js failed: " + cartText.slice(0, 300));
    }

    const cart = await cartRes.json();

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      throw new Error("Cart is empty");
    }

    const payload = {
      store_domain: myshopifyDomain,
      domain_name: window.location.host,
      store_currency: getCurrency(cart),
      store_logo: logo,
      amount: (cart.total_price || 0) / 100,
      products: (cart.items || []).map(function (item) {
        return {
          title: item.product_title || item.title || "Product",
          variant_title: item.variant_title || "",
          quantity: item.quantity || 1,
          price: (item.price || 0) / 100,
          image: item.image || "",
          id: item.product_id || "",
        };
      }),
    };
    redirectToPay(payload);
  }
  function toBase64(text) {
    const bytes = new TextEncoder().encode(text);

    let binary = "";
    for (const byte of bytes) {
      binary += String.fromCharCode(byte);
    }

    return btoa(binary);
  }

  const buyNow = document.querySelector(".custom-buy-now-button");
  if (buyNow) {
    buyNow.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      try {
        await handleButtonClick(this, async () => {
          await btnGoPay(this);
        });
      } catch (error) {
        console.error("PAY DEBUG:", error);
        alert(
          "读取 Shopify 订单信息失败：" +
            (error && error.message ? error.message : String(error)),
        );
      }
    });
  }
function findCustomCheckoutButton(e) {
  const path = typeof e.composedPath === "function" ? e.composedPath() : [];
  for (const el of path) {
    if (el && el.classList && el.classList.contains("custom-cart-checkout")) {
      return el;
    }
  }
  const t = e.target;
  if (t && typeof t.closest === "function") {
    return t.closest(".custom-cart-checkout");
  }
  return null;
}

window.addEventListener(
  "click",
  async function (e) {
    const cartBtn = findCustomCheckoutButton(e);
    if (!cartBtn) return;

    e.preventDefault();
    e.stopPropagation();

    try {
      await handleButtonClick(cartBtn, async () => {
        await btnGoPay(cartBtn);
      });
    } catch (error) {
      console.error("PAY DEBUG:", error);
      alert(
        "Failed to start checkout: " +
          (error && error.message ? error.message : String(error)),
      );
    }
  },
  true, 
);
